"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorNotificationSchema = exports.ErrorNotificationPayloadSchema = exports.SendNotificationMessageSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.SendNotificationMessageSchema = ruby_1.NotificationMessageSchema;
exports.ErrorNotificationPayloadSchema = (0, core_1.StrictObject)({
    error: typebox_1.Type.String(),
    data: typebox_1.Type.Unknown(),
});
exports.ErrorNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.GENERAL_ERROR, exports.ErrorNotificationPayloadSchema);
